import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, switchMap } from 'rxjs';
import { ProfileUpdateDto } from '../dtos/profile-update.dto';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Injectable({
  providedIn: 'root',
})
export class MyProfileService {
  private apiUrl = `${window.location.origin}/api/users/me`;

  constructor(
    private http: HttpClient,
    private oidcSecurityService: OidcSecurityService
  ) {}

  getUserProfile(token: string): Observable<any> {
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.get(this.apiUrl, { headers });
  }

  updateUserProfile(profile: ProfileUpdateDto): Observable<void> {
    return this.oidcSecurityService.getAccessToken().pipe(
      switchMap((token) => {
        const headers = { Authorization: `Bearer ${token}` };
        return this.http.patch<void>(this.apiUrl, profile, { headers });
      })
    );
  }
}
